<div [class.empty]="!src"
     class="main">
    <div #imageEditor class="image-editor">
        <div class="croppie-container">
            <img #croppie/>
        </div>
        <button (click)="removeProfileImage()"
                aria-label="Profilbild entfernen"
                class="button secondary icon-only close adjust-jh"
                i18n-aria-label="@@profile.imageSelector.btn.remove"
                type="button">
            <span class="icon icon-x"></span>
        </button>
    </div>
    <div class="placeholder">
        <input #input (change)="loadProfileImage(input.files)" accept="image/*" class="file-chooser" id="file-chooser"
               type="file">
        <label
                for="file-chooser"
                i18n="@@profile.imageSelector.placeholder.selectFile"
                i18n-title="@@profile.imageSelector.placeholder.selectFile"
                title="Profilbild auswählen"
        >Profilbild auswählen</label>
    </div>
</div>
